var React = require('react');

function WCollaborateWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFFFFF","fillOpacity":"1","d":"M0,64L80,80C160,96,320,128,480,122.7C640,117,800,75,960,90.7C1120,107,1280,181,1360,218.7L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"}));
}

WCollaborateWhite.defaultProps = {"viewBox":"0 0 1440 320"};

module.exports = WCollaborateWhite;

WCollaborateWhite.default = WCollaborateWhite;
